function checkExtension ({filename, allowedExtension}) {

    // console.log('checkExtension');
    // console.log('allowedExtension', allowedExtension);
    // console.log(filename);
    // return;

    if (filename === '') {
         return {
             // success: false,
             // message: 'Empty filename'
             success: true,
             message: ''
         }
    }

    const ext       = filename.split('.')
    const extValue  = ext[ext.length - 1]

    if( !allowedExtension.includes(extValue) ) {
        return {
            success: false,
            message: 'Not allowed extension'
        }
    }

    return {
        success: true,
        message: ''
    }

}

function checkSize({size, maxSize}) {

    if (size < maxSize) {

        return {
            success: true,
            message: '',
        }

    }

    return {
        success: false,
        message: 'File must be less then 1 Gb',
    }

}

export {checkExtension, checkSize};